<script>
import { required } from "vuelidate/lib/validators";

import name_residential_unit from "../../../helpers/list/name_residential_unit";
import city from "../../../helpers/list/city";
import type_residential_unit from "../../../helpers/list/type_residential_unit";
// import style_residential_unit from "../../../helpers/list/style_residential_unit";
import area_residential_unit from "../../../helpers/list/area_residential_unit";

export default {
  components: {},
  props: {},

  data() {
    return {
      name_residential_unit_id: "",
      city_id: "",
      type_residential_unit_id: "",
      // style_residential_unit_id: "",
      area_residential_unit_id: "",

      //lists
      list_name_residential_unit: name_residential_unit,
      list_city: city,
      list_type_residential_unit: type_residential_unit,
      // list_style_residential_unit: style_residential_unit,
      list_area_residential_unit: area_residential_unit,
    };
  },
  validations: {
    name_residential_unit_id: { required },
    city_id: { required },
    type_residential_unit_id: { required },
    // style_residential_unit_id: { required },
    area_residential_unit_id: { required },
    form: [
      "name_residential_unit_id",
      "city_id",
      "type_residential_unit_id",
      // "style_residential_unit_id",
      "area_residential_unit_id",
    ],
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <!-- شهيد -->
    <div class="row">
      <!-- title -->
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">حدد مواصفات قطعة الارض</h5></div>

      <b-form-group
        class="col-md-6 mb-3"
        label=" اسم قطعة الارض : "
        label-for="name_residential_unit_id"
      >
        <select
          class="form-control"
          id="name_residential_unit_id"
          v-model="name_residential_unit_id"
          :class="{ 'is-invalid': $v.name_residential_unit_id.$error }"
        >
          <option value="">اختر قطعة الارض</option>
          <option
            v-for="name_residential_unit in list_name_residential_unit"
            :value="name_residential_unit.id"
            :key="name_residential_unit.id"
          >
            {{ name_residential_unit.name }}
          </option>
        </select>
        <div v-if="$v.name_residential_unit_id.$error" class="invalid-feedback">
          <span v-if="!$v.name_residential_unit_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-6 mb-3" label=" المحافظة  : " label-for="city_id">
        <select
          class="form-control"
          id="city_id"
          v-model="city_id"
          :class="{ 'is-invalid': $v.city_id.$error }"
        >
          <option value="">اختر المحافظة</option>
          <option selected v-for="city in list_city" :value="city.id" :key="city.id">
            {{ city.name }}
          </option>
        </select>
        <div v-if="$v.city_id.$error" class="invalid-feedback">
          <span v-if="!$v.city_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group
        class="col-md-6 mb-3"
        label=" طريقة الدفع : "
        label-for="type_residential_unit_id"
      >
        <select
          class="form-control"
          id="type_residential_unit_id"
          v-model="type_residential_unit_id"
          :class="{ 'is-invalid': $v.type_residential_unit_id.$error }"
        >
          <option value="">اختر طريقة الدفع</option>
          <option
            v-for="type_residential_unit in list_type_residential_unit"
            :value="type_residential_unit.id"
            :key="type_residential_unit.id"
          >
            {{ type_residential_unit.name }}
          </option>
        </select>
        <div v-if="$v.type_residential_unit_id.$error" class="invalid-feedback">
          <span v-if="!$v.type_residential_unit_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>

      <b-form-group
        class="col-md-6 mb-3"
        label=" مساحة قطعة الارض : "
        label-for="area_residential_unit_id"
      >
        <select
          class="form-control"
          id="area_residential_unit_id"
          v-model="area_residential_unit_id"
          :class="{ 'is-invalid': $v.area_residential_unit_id.$error }"
        >
          <option value="">اختر مساحة قطعة الارض</option>
          <option
            v-for="area_residential_unit in list_area_residential_unit"
            :value="area_residential_unit.id"
            :key="area_residential_unit.id"
          >
            {{ area_residential_unit.name }}
          </option>
        </select>
        <div v-if="$v.area_residential_unit_id.$error" class="invalid-feedback">
          <span v-if="!$v.area_residential_unit_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
    </div>
  </div>
  <!-- end page title -->
</template>
